module.exports = __webpack_public_path__ + "img/user_card_coupon.b6b4c658.png";